<template>
    <div class="dots">
        <div class="circle" v-for="(dot, i) in getDecisionCount" :key="i" :class="{ filled: i <= getDecisionRound }"></div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    
    export default {
        name : "Dots",
        computed : {
            ...mapGetters([
                "getDecisionCount",
                "getDecisionRound"
            ])
        }
    }
</script>